/**
 * Zero pads a numeral or integer so that it is 2 characters in length.
 * @param {string|number} value The value to be padded with 0s
 * @returns string
 */
export function zeroPadDate(value) {
  return `${value}`.padStart(2, "0");
}
